import { Component, HostListener, OnInit } from '@angular/core';
import { query } from '@angular/core/src/render3/instructions';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalService } from '../../Services/global.service';
import { UserService } from '../../Services/Users.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from "ngx-cookie-service";
import { AuthService } from '../../Services/AuthGard.service';
import * as jwt_decode from 'jwt-decode';
import { CreateCommunityService } from "../../Services/create-community.service";
import { HttpUrlEncodingCodec } from '@angular/common/http';
import { Configuration } from '../../config/config';

declare var $;
@Component({
  selector: 'app-cognito-route',
  templateUrl: './cognito-route.component.html',
  styleUrls: ['./cognito-route.component.css'],
  providers: [CreateCommunityService]
})
export class CognitoRouteComponent implements OnInit {
  
  codec = new HttpUrlEncodingCodec;
  langList: any;
  lang_name: any;
  lang_id: any;
  token: string;
  current_user: any;
  buttonTitle: any;
  selectedGame: any;
  ssoLoginData: boolean;
  ssoSignUpCommunityData: any;
  URL: string = "";
  redirectURL: any;
  userExistStatusCode: string;
  ssoSignUpCommunityData1: any;
  userExistErrorStatusCode: any;
  Typechecking: any;
  authenticationType: any;
  time: any;
  messageData: any;
  selectedGame1: any;
  languageSelected: string;
  supportMessage: string;
  configEMailListData: any;
  resAuth: any;
  currentUsername: any;

  constructor(private route: ActivatedRoute, private router: Router, private translateService: TranslateService, private cookieService: CookieService,
    private userService: UserService, private communityService: CreateCommunityService, private globalService: GlobalService, private authService: AuthService) {
    this.ssoLoginData = JSON.parse(localStorage.getItem('isSSOLogin'));
    console.log(this.ssoLoginData, "ssoLoginData");
    this.ssoSignUpCommunityData = JSON.parse(localStorage.getItem('CompanyData'));
    this.ssoSignUpCommunityData1 = JSON.parse(localStorage.getItem('CommResources'));
    this.authenticationType = localStorage.getItem('authenticationType');
    console.log(this.ssoSignUpCommunityData, "ssoSignUpCommunityData");
    console.log(this.authenticationType, "authenticationTypeauthenticationTypeauthenticationType");
    localStorage.clear();
    sessionStorage.clear();
    var event = new CustomEvent("Show Header On Login", { "detail": "Example of an event" });
    document.dispatchEvent(event);
    // let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;
    // let lang_name = defaultLangData && defaultLangData.lang_name ? defaultLangData.lang_name : 'English';
    // this.translateService.reloadLang(lang_name);
  }

  ngOnInit() {

    if (this.ssoSignUpCommunityData == null || this.ssoSignUpCommunityData1 == null || this.ssoLoginData == null) { //direct IDP related code in this if
      this.ssoLoginData = JSON.parse(localStorage.getItem('isSSOLogin')) ? JSON.parse(localStorage.getItem('isSSOLogin')) : true;
      console.log("ssoLoginData isSSOLogin value", this.ssoLoginData);
      this.communityService.refreshToken();
      this.route.fragment.subscribe((fragment: string) => {
        console.log("clent id response", fragment);
        const urlParams = new URLSearchParams(fragment);
        const token = urlParams.get('access_token');
        this.resAuth = jwt_decode(token);
        console.log("Decoded token", this.resAuth);
        let obj2 = {
          client_id: this.resAuth.client_id
        }
        this.communityService.getCommIdByClientId(obj2).subscribe(clientIdRes => {
          console.log("getCommIdByClientId", clientIdRes);
          console.log("getCommIdByClientId data", clientIdRes.data);
          if (clientIdRes.data.length > 0) {
            console.log("getCommIdByClientId only client id", clientIdRes.data[0].comm_id);
            let obj1: any;
            if (clientIdRes.data[0].comm_id != " ") {
              obj1 = {
                comm_id: clientIdRes.data[0].comm_id,
              }
            } else {
              obj1 = {
                comm_id: clientIdRes.data[0].comm_id,
              }
            }
            this.userService.getRegisterDatafromCommunityID(obj1)
              .subscribe(response => {
                if (response.success) {
                  localStorage.setItem('Typechecking', response.data.authenticationType);
                  localStorage.setItem('authenticationType', response.data.authenticationType);
                  let commResObj = {
                    community_id: response.data.comm_id,
                    community_name: response.data.comm_name,
                  };
                  localStorage.setItem('CommResources', JSON.stringify(commResObj));
                  this.Typechecking = localStorage.getItem('Typechecking');
                  this.redirectURL = response.data.loginUrl;
                } else {
                  console.log("Error");
                }
              });

            const parsedHash = new URLSearchParams(
              this.route.snapshot.fragment
            );

            $('.modal-backdrop').css('display', 'none');
            $("#preloader").css('display', 'block');
            this.token = parsedHash.get("id_token");
            console.log(this.token, "token token");
            if (this.ssoLoginData === true) {
              console.log("login object", obj1);
              this.checkForSSOToken(this.token, obj1.comm_id);
              localStorage.removeItem("isSSOLogin");
            }
            else {
              //  register api with signup
              let obj;
              obj = {
                community_id: clientIdRes.data[0].comm_id,
                created_by: "system"
              }
              console.log("register sso api input", obj);
              this.userService.getRegisterFromSSO(this.token, obj).subscribe(res => {
                console.log("registration api response", res)
                if (res.status == 200) {
                  let obj1 = {
                    comm_id: res.data.community_id,
                  }
                  if (res.data.signUpStatus) {
                    this.checkForSSOToken(this.token, obj1.comm_id);
                  }
                } else if (res.status == 400) {
                  this.userExistStatusCode = "206";
                  $('#profilesuccessModal').modal('show');
                  $("#preloader").css('display', 'none');
                  console.log("dtabase code Error")
                }
                else if (res.msg.status == "710") {
                  this.userExistStatusCode = "2011";
                  $("#preloader").css('display', 'none');
                  $('#exampleModal').modal('show');
                  this.checkForSSOToken(this.token, obj1.comm_id);
                  setTimeout(function () {
                    $('#exampleModal').modal('hide');
                  }, 3000);
                }
                else if (res.msg.status == "711") {
                  this.checkForSSOToken(this.token, obj1.comm_id);
                }
                else {
                  console.log("Nothing happen")
                }
              });
            }
          } else {
            this.userExistStatusCode = "239";
            this.ssoLoginData = false;
            $('#profilesuccessModal').modal('show');
            $("#preloader").css('display', 'none');
          }

        })
      })
    } else {
      this.communityService.refreshToken();
      let obj1: any;
      if (this.ssoSignUpCommunityData.communityID != "global") {
        // alert("community id is global");
        obj1 = {
          comm_id: this.ssoSignUpCommunityData.communityID,
        }
      } else {
        // alert("community id is not global");
        obj1 = {
          comm_id: this.ssoSignUpCommunityData1.community_id,
        }
      }
      this.userService.getRegisterDatafromCommunityID(obj1)
        .subscribe(response => {
          if (response.success) {
            localStorage.setItem('Typechecking', response.data.authenticationType);
            localStorage.setItem('authenticationType', response.data.authenticationType);
            let commResObj = {
              community_id: response.data.comm_id,
              community_name: response.data.comm_name,
            };
            localStorage.setItem('CommResources', JSON.stringify(commResObj));
            this.Typechecking = localStorage.getItem('Typechecking');
            this.redirectURL = response.data.loginUrl;
          } else {
            console.log("Error");
          }
        });

      const parsedHash = new URLSearchParams(
        this.route.snapshot.fragment
      );

      $('.modal-backdrop').css('display', 'none');
      $("#preloader").css('display', 'block');
      this.token = parsedHash.get("id_token");
      console.log(this.token, "token token");
      if (this.ssoLoginData === true) {
        console.log("login object", obj1);
        this.checkForSSOToken(this.token, obj1.comm_id);
      } else {
        //  register api with signup
        let obj;
        if (this.ssoSignUpCommunityData1.batch_id) {
          obj = {
            community_id: this.ssoSignUpCommunityData1.community_id,
            batch_id: this.ssoSignUpCommunityData1.batch_id,
            created_by: "system"
          }
        } else {
          obj = {
            community_id: this.ssoSignUpCommunityData1.community_id,
            created_by: "system"
          }
        }
        console.log("register sso api input", obj);
        this.userService.getRegisterFromSSO(this.token, obj).subscribe(res => {
          console.log("registration api response", res)
          if (res.status == 200) {
            let obj1 = {
              comm_id: res.data.community_id,
            }
            if (res.data.signUpStatus) {
              this.checkForSSOToken(this.token, obj1.comm_id);
            }
          } else if (res.status == 400) {
            this.userExistStatusCode = "206";
            $('#profilesuccessModal').modal('show');
            $("#preloader").css('display', 'none');
            console.log("dtabase code Error")
          }
          else if (res.msg.status == "710") {
            this.userExistStatusCode = "2011";
            $("#preloader").css('display', 'none');

            $('#exampleModal').modal('show');
            this.checkForSSOToken(this.token, obj1.comm_id);
            setTimeout(function () {
              $('#exampleModal').modal('hide');
            }, 3000);
          }
          else if (res.msg.status == "711") {
            this.checkForSSOToken(this.token, obj1.comm_id);
          }
          else {
            console.log("Nothing happen")
          }
        });
      }
    }
  };

  closeErrorModal() {
    $('#exampleModal').modal('hide');
  }

  closeSelectionModal() {
    let current_user = JSON.parse(localStorage.getItem('currentUser'));
    const userRole = this.codec.encodeValue(current_user.user.role);
    const cleanUserRole = userRole.replace(/%20/g, ' ').trim();
    if (cleanUserRole == "Manager") {
      $('#dashboardSelection').modal('hide');
      this.router.navigate(['/dashboard/learner/learnerDashboard']);
    } else if (cleanUserRole == "admin") {
      $('#adminDashboardSelection').modal('hide');
      $("#preloader").css('display', 'block');
      this.router.navigate(['/dashboard/portal/portalDashboard']);
    } else if (cleanUserRole == "Community Admin") {
      if (current_user.user.question != "") {
        this.userService
          .getCommunityByCommunityID(current_user.user.community_id)
          .subscribe((res) => {
            localStorage.setItem(
              "activationStatus",
              res.data.activation_status
            );
            localStorage.setItem(
              "certificateManagement",
              res.data.config[0].certficate_mgmt
            );
            sessionStorage.setItem("loginPage", "yes");
            $("#preloader").css("display", "none");
            // $('#dashboardSelection').modal('show');
            this.router.navigate(["/dashboard/portal/communityDashboard"]);
          });
      } else {
        this.router.navigate(["/communityUser"]);
      }
    }
    // $('#dashboardSelection').modal('hide');
    // this.router.navigate(['/dashboard/learner/learnerDashboard']);
  }
  redirectToManagerPortal() {
    $('#dashboardSelection').modal('hide');
    const communityIdForManager = this.codec.encodeValue(this.current_user.user.community_id);
    const userNameForManager = this.codec.encodeValue(this.current_user.user.username);
    const clientKeyForManager = this.codec.encodeValue(this.current_user.user.client_id);
    const userRole = this.codec.encodeValue(this.current_user.user.role);
    const community_username_type = this.codec.encodeValue(this.current_user.user.community_username_type);
    const token = this.codec.encodeValue(this.current_user.token);
    let obj = {
      "c_id": communityIdForManager,
      "uname": userNameForManager,
      "ckey": clientKeyForManager,
      "community_username_type":community_username_type,
      "token":token,
      "userType": userRole
    }
    
    this.cookieService.set("skelObj", JSON.stringify(obj), undefined, '/', '.alignorgames.com', false);
    const managerPortalUrl = Configuration.ManagerBaseURL + "dashboard";
    console.log("encoded community id in redirectToManagerPortal", communityIdForManager);
    console.log("encoded username in redirectToManagerPortal", userNameForManager);
    window.location.href = managerPortalUrl;
  }

  closeSuccessModal() {

    let obj2 = {
      client_id: this.resAuth.client_id
    }
    if (this.ssoSignUpCommunityData == null || this.ssoSignUpCommunityData1 == null) {
      this.communityService.getCommIdByClientId(obj2).subscribe(clientIdRes => {
        if (clientIdRes.data.length > 0) {
          var obj = {
            comm_id: clientIdRes.data[0].comm_id,
          }
          console.log("close modal object input", obj);
          this.userService.getRegisterDatafromCommunityID(obj)
            .subscribe(res => {
              console.log("SSO_INFO api response", res);
              if (res.data.subDomainName) {
                window.location.href = res.data.subDomainName + "/login";
              } else {
                window.location.href = window.location.origin + "/login?token=" + res.data.loginUrl;
              }
            })
        }else{
          this.router.navigate(['login']);
        }
        

      })
    } else {
      var obj = {
        comm_id: this.ssoSignUpCommunityData1.community_id,
        // subDomainName:'abc'
      }





      console.log("close modal object input", obj);
      
      this.userService.getRegisterDatafromCommunityID(obj)
        .subscribe(res => {
          let loginUrl = this.cookieService.get("loginUrl");
          console.log("SSO_INFO api response", res);
          if (loginUrl) {
            window.location.href = window.location.origin + "/login?token=" + res.data.loginUrl;
          }else if(res.data.subDomainName){
            window.location.href = res.data.subDomainName + "/login";
          } else {
            window.location.href = window.location.origin + "/login?token=" + res.data.loginUrl;
          }
        })
    }
  }

  checkForSSOToken(token, _comm_id) {


    this.communityService.getConfigureEmailWithoutToken(_comm_id).subscribe(res => {
      // alert(_comm_id);
      if (res.data[0].email != undefined) {
        this.configEMailListData = res.data[0].email;
        console.log("COnfigure email list without token", this.configEMailListData);
        this.supportMessage = "Please write to" + " " + this.configEMailListData + " " + "for assistance";
      }
      else {
        this.configEMailListData = res.data;
        console.log("COnfigure Admin email list without token", this.configEMailListData);
        console.log("COnfigure Admin email  without token", res.data[0].mail_id);
        this.supportMessage = "Please write to" + " " + res.data[0].mail_id + " " + "for assistance";

      }
    });


    this.languageSelected = localStorage.getItem('CommResources');
    console.log("Alert message language", this.languageSelected);
    this.translateService.use(this.languageSelected);
    this.translateService.get(['REGISTRATION.REGISTER_USER_SERVER_MSG.USER_ALREADY_EXIST_IN_SYSTEM']).subscribe(label => {
      this.selectedGame1 = label;
      console.log("converted array", this.selectedGame1);
    })
    this.userService.checkForToken(token, _comm_id).subscribe(response => {
      console.log("username exist api response", response);
      this.userExistStatusCode = response.statusCode;
      if (response.statusCode == 200) {
        let userObj: any = {};
        userObj.user = response.data;
        userObj.token = response.token;
        userObj.msg = response.message;
        localStorage.setItem('currentUser', JSON.stringify(userObj));
        this.current_user = JSON.parse(localStorage.getItem('currentUser'));
        console.log("username is", this.current_user.user.username);
        this.currentUsername = this.current_user.user.username;
        console.log('this.current_user====>', this.current_user);
        localStorage.setItem('Typechecking', this.Typechecking);
        localStorage.setItem('authenticationType', this.authenticationType);
        localStorage.setItem('profile_pic', JSON.stringify(userObj.user.profile_pic));
        localStorage.setItem('userRole', userObj.user.role);
        this.userService.getCommunityNameByCommunityID(response.data.community_id).subscribe(comm => {
          let commResObj = {
            community_id: comm.data.comm_id,
            community_name: comm.data.comm_name,
            resource_config: comm.data.resource_config
          };
          localStorage.setItem('CommResources', JSON.stringify(commResObj));
        });
        localStorage.setItem('Volume', '0.5');
        let LangData = this.cookieService.get('changeLanguage') ? JSON.parse(this.cookieService.get('changeLanguage')) : "English";
        console.log(LangData, "LangData");
        if (LangData.isChangeLang) {
          this.lang_name = LangData.lang_name ? LangData.lang_name : 'English';
          this.lang_id = LangData.lang_id ? LangData.lang_id : 'English';
        } else {
          this.lang_name = response.data.defaultLang ? response.data.defaultLang : 'English';

          this.userService.getAllLanguage().subscribe(lang => {
            if (lang.success) {
              for (var i = 0; i < lang.data.length; i++) {
                if (lang.data[i].lang_name === this.lang_name) {
                  this.lang_id = lang.data[i].language_id;
                  console.log(this.lang_id, "lang_id======>login");
                }
              }
              localStorage.setItem('defaultLangId', this.lang_id);
            }
          });
          // this.lang_id = response.data.defaultLangId ? response.data.defaultLangId : 'English';
        }
        localStorage.setItem('defaultLang', this.lang_name);
        // localStorage.setItem('defaultLangId', this.lang_id);

        this.translateService.reloadLang(this.lang_name);
        // let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';

        const CompanyData = JSON.parse(localStorage.getItem('CompanyData'));
        localStorage.setItem('CompanyData', JSON.stringify(CompanyData));

        if (this.current_user.user.role == "Learner") {
          localStorage.setItem('guideVideoSeenStatus', 'true');
          this.globalService.getTranslationTour();
          sessionStorage.setItem('loginPage', 'yes');
          $("#preloader").css('display', 'none');
          this.router.navigate(['/dashboard/learner/learnerDashboard']);
        } else if (this.current_user.user.role == "Manager") {
          localStorage.setItem('guideVideoSeenStatus', 'true');

          this.globalService.getTranslationTour();
          sessionStorage.setItem('loginPage', 'yes');
          $("#preloader").css('display', 'none');
          $('#dashboardSelection').modal('show');
        }else if (this.current_user.user.role == "Community Admin") {
          localStorage.setItem('guideVideoSeenStatus', 'true');

          this.globalService.getTranslationTour();
          sessionStorage.setItem('loginPage', 'yes');
          $("#preloader").css('display', 'none');
          $('#dashboardSelection').modal('show');
        }else if (this.current_user.user.role == "Admin") {
          localStorage.setItem('guideVideoSeenStatus', 'true');

          this.globalService.getTranslationTour();
          sessionStorage.setItem('loginPage', 'yes');
          $("#preloader").css('display', 'none');
          $('#dashboardSelection').modal('show');
        }
      }
      // else if(response.statusCode == 206)
      // {
      //   let obj;
      //   if (this.ssoSignUpCommunityData1.batch_id) {
      //     obj = {
      //       community_id: this.ssoSignUpCommunityData1.community_id,
      //       batch_id: this.ssoSignUpCommunityData1.batch_id,
      //       created_by: "system"
      //     }
      //   } else {
      //     obj = {
      //       community_id: this.ssoSignUpCommunityData1.community_id,
      //       created_by: "system"
      //     }
      //   }
      //   console.log("register sso api input of 206 statuscode",obj);
      // // alert("register sso api input");
      //   this.userService.getRegisterFromSSO(this.token, obj).subscribe(res => {
      //     console.log("registration api response of 206 statuscode",res);
      //     let obj1 = {
      //       comm_id: res.data.community_id,
      //     }
      //     if (res.status == 200) {
      //       let obj1 = {
      //         comm_id: res.data.community_id,
      //       }
      //       if (res.data.signUpStatus) {
      //         this.checkForSSOToken(this.token,obj1.comm_id);
      //       }
      //     }else if(res.status == 400) {
      //       // alert("user not exist");
      //       this.userExistStatusCode = "206";
      //       $('#profilesuccessModal').modal('show');
      //       $("#preloader").css('display', 'none');
      //       console.log("dtabase code Error")
      //     }
      //     else if (res.msg.status == "710") {
      //       this.userExistStatusCode = "2011";
      //       $("#preloader").css('display', 'none'); 

      //       $('#exampleModal').modal('show');
      //       this.checkForSSOToken(this.token,obj1.comm_id);
      //       setTimeout(function(){
      //         $('#exampleModal').modal('hide');
      //     }, 3000);
      //       // $('#exampleModal').modal('hide');

      //     }
      //     else if (res.msg.status == "711") {
      //      alert('different community');
      //       this.checkForSSOToken(this.token,obj1.comm_id);

      //     }
      //     else{
      //       console.log("Nothing happen")
      //     }

      //   })

      // } 
      else if (response.statusCode == 206 || response.statusCode == 207 || response.statusCode == 503 || response.statusCode == 400 || response.statusCode == 403 || response.statusCode == 404) {


        // this.supportMessage = "Please write to"+this.configEMailListData+"for assistance.";
        // this.communityService.getConfigureEmailWithoutToken(_comm_id).subscribe(response => {
        //   console.log("configure emmail response",response);
        //   let support_email = "abc@gmail.com";
        //   this.supportMessage = "Please write to"+support_email+"for assistance.";
        // });
        $("#preloader").css('display', 'none');
        $('#profilesuccessModal').modal('show');

      }
      else {
        console.log("Error", 'community Id and user community Id not matches');
        console.log("community Id and user community Id not matches")
      }
    }, error => {
      this.userExistErrorStatusCode = error.statusCode;
      if (error.statusCode == 500 || error.statusCode == 401 || error.statusCode == 503 || error.statusCode == 400 || error.statusCode == 403 || error.statusCode == 404) {
        $('#profilesuccessModal').modal('show');
        $("#preloader").css('display', 'none');
      }
    });
  }
}
function $timeout(arg0: () => void, arg1: number): any {
  throw new Error('Function not implemented.');
}




// WEBPACK FOOTER //
// ./src/app/Screens/cognito-route/cognito-route.component.ts